import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
// import logger from '../../services/LocalServer/logger';
import localRequest from '../../services/LocalServer/localRequest';
import request from '../../services/Request';
import defaultSS from '../../Icons/defaultSS.png';

const getSSbyMachine = `${process.env.REACT_APP_LOCAL_API}/getSS`;
const getSSbyMachineR = `${process.env.REACT_APP_SERVER_API}/screenSaverByMachine/`;

const ImageSlider = (props) => {
  const { stat, cartQuantity, setStat, defaultStat, cleanUp, setLinkPromo } = props;
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  const testMode = localStorage.getItem('testMode') === 'true' ? 'true' : 'false';
  const machineID = props.id;
  const linkToURL = `/machineUI/home/${machineID}/${testMode}`;
  const timeoutRef = useRef(null);
  const myRef = useRef(null);
  const [data, setData] = useState([]);
  const [SliderData, setSliderData] = useState([]);
  const [current, setCurrent] = useState(0);
  const [interval, setInterval] = useState(5);
  const [referTo, setReferTo] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      if (isLocal) {
        await localRequest({
          method: 'get',
          url: getSSbyMachine,
        })
          .then((res) => {
            if (res.data.slider) {
              setData(res.data);
              setReferTo(res.data.referTo);
              setSliderData(res.data.slider);
              setInterval(res.data.interval * 1000);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        await request({
          method: 'get',
          url: getSSbyMachineR + machineID,
        })
          .then((res) => {
            console.log(res.data);
            if (res.data.slider) {
              setData(res.data);
              setSliderData(res.data?.slider);
              setReferTo(res.data?.referTo);
              setInterval(res.data?.interval * 1000);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    };

    localRequest({
      method: 'post',
      url: `${process.env.REACT_APP_LOCAL_API}/resetStatus`,
      data: {},
    }).then(() => {});

    fetchData();
  }, []);

  useEffect(() => {
    localRequest({
      method: 'post',
      url: `${process.env.REACT_APP_LOCAL_API}/paymentUpdate`,
      data: {
        status: 'CANCEL',
      },
    });
  }, []);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  const nextSlide = async () => {
    setCurrent(current === SliderData.length - 1 ? 0 : current + 1);
  };

  function clickImage(index) {
    setStat(defaultStat);
    if (SliderData[index].promo) {
      console.log(SliderData[index]);
      stat.banner._id = SliderData[index]._id;
      stat.banner.file = SliderData[index].url;
      stat.banner.count = 1;
      stat.banner.ssID = data._id;
      stat.banner.ssTitle = data.name;
      stat.banner.conv = 0;
      setStat(stat);
    }
  }

  //end of session
  useEffect(() => {
    setLinkPromo({ p: '', id: '' });
    const now = new Date();
    const diff = (now.getTime() - stat.time.getTime()) / 1000;
    stat.time = now;
    stat.session_time = diff;
    if (cartQuantity > 0 && stat.session_com === 0) {
      stat.cart_aband = 1;
    }
    cleanUp();
    localRequest({
      method: 'post',
      url: `/report`,
      data: stat,
    }).then(() => {});
  }, []);

  useEffect(() => {
    if (SliderData?.length > 0) {
      resetTimeout();
      // console.log(SliderData[current].promo);
      if (SliderData[current].promo) {
        if (SliderData[current].promo.category?.length > 0) {
          try {
            props.setLinkPromo({ p: 'cate', id: SliderData[current].promo.category[0] });
          } catch (e) {
            console.log(e);
          }
        }
        if (SliderData[current].promo.product?.length > 0) {
          try {
            props.setLinkPromo({ p: 'prod', id: SliderData[current].promo.product[0] });
          } catch (e) {
            console.log(e);
          }
        }
      } else {
        props.setLinkPromo({ p: '', id: '' });
      }
      if (SliderData[current].video === true) {
        myRef.current.onended = function () {
          nextSlide();
        };
      } else {
        timeoutRef.current = setTimeout(nextSlide, interval);
      }
      return () => {
        resetTimeout();
      };
    }
  }, [current, SliderData]);

  // if (!Array.isArray(SliderData) || SliderData.length <= 0) {
  //   return <Link to={linkToURL} />;
  // }

  return (
    <Link className="l-slider" to={linkToURL}>
      {SliderData?.length > 0 ? (
        SliderData.map((slide, index) => {
          const ssURL1 = isLocal
            ? `${process.env.REACT_APP_LOCAL_API}/pictures/screensaver/${slide.url}`
            : `${process.env.REACT_APP_SERVER_API}/videos/${slide.url}/${referTo}`;
          const ssURL2 = isLocal
            ? `${process.env.REACT_APP_LOCAL_API}/pictures/screensaver/${slide.url}`
            : `${process.env.REACT_APP_SERVER_API}/pictures/${slide.url}/${referTo}`;
          return (
            <div
              className={index === current ? 'l-slide active' : 'l-slide'}
              key={index}
              onClick={() => {
                clickImage(index);
              }}
            >
              {slide.video == true
                ? index === current && (
                    <video
                      ref={myRef}
                      src={ssURL1}
                      alt="idle video"
                      className="l-video"
                      autoPlay
                      muted
                      loop={SliderData?.length === 1 ? true : false}
                    />
                  )
                : index === current && <img src={ssURL2} alt="idle image" className="l-image" />}
            </div>
          );
        })
      ) : (
        <img src={defaultSS} alt="idle image" className="l-image" />
      )}
    </Link>
  );
};

export default ImageSlider;
